import React from 'react';
import { Badge } from 'react-bootstrap';
import { OrderStatusBadge, BADGE_COLORS } from '../../../../Common/BadgeStyles';

interface ReturnBadgeProps {
  returnStatus?: string;
  refundStatus?: string;
}

/**
 * Reusable component for rendering return status badges
 * Handles all badge logic for return items (REQUESTED, APPROVED, REJECTED, REFUNDED, etc.)
 */
const ReturnBadge: React.FC<ReturnBadgeProps> = ({ returnStatus, refundStatus }) => {
  const refundStatusUpper = refundStatus?.toUpperCase()?.trim();
  const returnStatusUpper = returnStatus?.toUpperCase()?.trim();

  if (returnStatusUpper) {
    let displayText = '';
    let badgeColors: typeof BADGE_COLORS.STATUS.ACTIVE | typeof BADGE_COLORS.FULFILLMENT.PICKUP | typeof BADGE_COLORS.STATUS.INACTIVE | typeof BADGE_COLORS.RETURN = BADGE_COLORS.STATUS.ACTIVE;
    
    switch (returnStatusUpper) {
      case 'REQUESTED':
        displayText = 'Requested';
        badgeColors = BADGE_COLORS.RETURN;
        break;
      case 'APPROVED':
        displayText = 'Approved';
        badgeColors = BADGE_COLORS.FULFILLMENT.PICKUP;
        break;
      case 'REJECTED':
        displayText = 'Rejected';
        badgeColors = BADGE_COLORS.STATUS.INACTIVE;
        break;
      case 'REFUNDED':
        displayText = 'Completed';
        badgeColors = BADGE_COLORS.STATUS.ACTIVE;
        break;
      case 'COMPLETED':
        displayText = 'Completed';
        badgeColors = BADGE_COLORS.STATUS.ACTIVE;
        break;
      default:
        displayText = returnStatusUpper.charAt(0) + returnStatusUpper.slice(1).toLowerCase();
        badgeColors = BADGE_COLORS.RETURN;
    }
    
    return (
      <Badge
        bg=""
        className="shop-order-status-badge"
        style={{
          backgroundColor: badgeColors.backgroundColor,
          color: badgeColors.color,
          borderColor: badgeColors.borderColor,
          border: `1px solid ${badgeColors.borderColor}`,
        } as React.CSSProperties}
      >
        {displayText}
      </Badge>
    );
  }

  if (refundStatus && typeof refundStatus === 'string' && refundStatusUpper && refundStatusUpper !== '' && refundStatusUpper !== 'NULL' && refundStatusUpper !== 'UNDEFINED') {
    if (refundStatusUpper === 'INITIATED') {
      return (
        <Badge
          bg=""
          className="shop-order-status-badge"
          style={{
            backgroundColor: BADGE_COLORS.FULFILLMENT.PICKUP.backgroundColor,
            color: BADGE_COLORS.FULFILLMENT.PICKUP.color,
            borderColor: BADGE_COLORS.FULFILLMENT.PICKUP.borderColor,
            border: `1px solid ${BADGE_COLORS.FULFILLMENT.PICKUP.borderColor}`,
          } as React.CSSProperties}
        >
          Initiated
        </Badge>
      );
    }
    
    if (refundStatusUpper === 'COMPLETED' || refundStatusUpper === 'PROCESSED' || refundStatusUpper === 'SUCCESS') {
      return (
        <Badge
          bg=""
          className="shop-order-status-badge"
          style={{
            backgroundColor: BADGE_COLORS.STATUS.ACTIVE.backgroundColor,
            color: BADGE_COLORS.STATUS.ACTIVE.color,
            borderColor: BADGE_COLORS.STATUS.ACTIVE.borderColor,
            border: `1px solid ${BADGE_COLORS.STATUS.ACTIVE.borderColor}`,
          } as React.CSSProperties}
        >
          Completed
        </Badge>
      );
    }
    return (
      <Badge
        bg=""
        className="shop-order-status-badge"
        style={{
          backgroundColor: BADGE_COLORS.FULFILLMENT.PICKUP.backgroundColor,
          color: BADGE_COLORS.FULFILLMENT.PICKUP.color,
          borderColor: BADGE_COLORS.FULFILLMENT.PICKUP.borderColor,
          border: `1px solid ${BADGE_COLORS.FULFILLMENT.PICKUP.borderColor}`,
        } as React.CSSProperties}
      >
        {refundStatusUpper.charAt(0) + refundStatusUpper.slice(1).toLowerCase()}
      </Badge>
    );
  }

  return <OrderStatusBadge status="RETURN" />;
};

export default ReturnBadge;
